import api from "@/api/api-v2-config";

export async function getMetricsListAxios() {    
    return await api.get("metricss/metrics?PageNumber=1&PageSize=10000");
}

export async function deleteMetricAxios(id) {    
    return await api.delete("metricss/metric?Id=" + id);
}

export async function postMetricAxios(metric) {    
    return await api.post("metricss/metrics", metric);
}

export async function putMetricAxios(metric) {    
    return await api.put("metricss/metrics", metric);
}

export async function getMetricByIDAxios(id) {    
    return await api.get("metricss/metric" + id);
}